const FILENAME_TOKEN_RE = /[\w\-. ]+\.(?:pdf|csv|xlsx?|docx?|txt|md|eml|json|png|jpe?g|log)/gi;

function normalizeName(value) {
  return String(value || "")
    .toLowerCase()
    .trim();
}

function stripSuffixes(name) {
  return String(name)
    .replace(/#[a-z0-9_\-]+$/i, "")
    .trim();
}

function extractFilenames(text) {
  const matches = String(text || "").match(FILENAME_TOKEN_RE) || [];
  return matches.map((m) => m.trim());
}

export function parseWhereToLook(entry) {
  const raw = String(entry || "").trim();
  if (!raw) return { filename: "", entity: "", page: "", section: "", display: "" };

  let page = "";
  const pageMatch = raw.match(/\(?\b(?:page|p\.?|pg\.?)\s*\.?\s*(\d{1,4})\)?/i);
  if (pageMatch) page = pageMatch[1];

  let section = "";
  const sectionMatch = raw.match(/[§#]\s*([\d.]+)|\b(?:section|sec)\b\s*\.?\s*([\d.]+)/i);
  if (sectionMatch) section = sectionMatch[1] || sectionMatch[2] || "";

  const entityMatch = raw.match(/['"\u201C\u201D]\s*([^'"\u201C\u201D]+)\s*['"\u201C\u201D]/);
  const entity = entityMatch ? entityMatch[1].trim() : "";

  const filename = extractFilenames(raw)[0] || "";

  return {
    filename,
    entity,
    page,
    section,
    display: entity || filename || raw,
  };
}

export function buildSourceIndex(docs = [], artifacts = []) {
  const byName = new Map();
  const byBasename = new Map();

  const add = (doc) => {
    const filename = String(doc?.filename || "");
    if (!filename) return;
    const norm = normalizeName(filename);
    const base = norm.split(/[\\/]/).pop();
    if (!byName.has(norm)) byName.set(norm, doc);
    if (!byBasename.has(base)) byBasename.set(base, doc);
  };

  (Array.isArray(docs) ? docs : []).forEach(add);
  (Array.isArray(artifacts) ? artifacts : []).forEach(add);

  return {
    resolve(entry) {
      const candidates = [entry, ...extractFilenames(entry)];
      for (const raw of candidates) {
        const cleaned = stripSuffixes(raw).trim();
        if (!cleaned) continue;
        const norm = normalizeName(cleaned);
        if (byName.has(norm)) return byName.get(norm);
        const base = norm.split(/[\\/]/).pop();
        if (byBasename.has(base)) return byBasename.get(base);
      }
      return null;
    },
  };
}
